import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { useMutation } from "@tanstack/react-query";

const pauseResumeTestSuite = async ({ tsrid, message }) => {
     const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  //tcrid --> is actually the test suite results id, naming the argument tsrid to avoid confusion. (backend is using tcrid which is actually test suite results id)

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=putPauseAction&token=${user.token}&tcrid=${tsrid}&message=${message}`
  )
  return response.data;
}


const usePauseResumeTestSuiteMutation = (options = {}) => {
    return useMutation({
        mutationFn: pauseResumeTestSuite,
        ...options,
    });
};

export default usePauseResumeTestSuiteMutation;